<template>
  <a class="c-button__link" :href="url">
    <button
      type="button"
      class="c-button"
      :disabled="isDisabled"
    >
      <slot />
    </button>
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  url: string
  disabled?: boolean
}>(), { disabled: undefined })

// by default, the button is not disabled
const isDisabled = computed<boolean>(() => {
  if (props.disabled !== undefined) {
    return props.disabled
  }
  return false
})
</script>
